import { ENV } from '@/config/env';
export const links = {
  privacyPolicy: `/privacy-policy`,
  termsOfUse: ENV.VITE_TERMS_OF_USE_URL,
  login: {
    main: `/`,
    sso: `/sso`,
    storeSelection: `/store-selection`,
    accountSelection: `/account-selection`,
    forgotPassword: `/forgot-password`,
    resetPassword: `/reset-password`,
    activateUser: `/activate-user`,
    acceptTerms: `/accept-terms`,
  },
  panel: `/`,
  quotes: {
    list: `/quotes`,
    new: `/quotes/new`,
    steps: `/quotes/new/steps`,
    newProduct: `/quotes/newProduct`,
    newContract: `/quotes/contract/new`,
    contractSteps: `/quotes/contract/new/steps`,
    cart: (dealId = ':dealId') => `/quotes/cart/${dealId}`,
  },
  contract: `/contract`,
  userProfile: {
    profile: `/user-profile/profile`,
    password: `/user-profile/password`,
    userProfileOptions: `/user-profile/`,
  },
  pricer: `/pricer`,
  clients: `/clients`,
  dealer: `/dealer`,
  dealers: `/dealers`,
  store: `/store`,
  stores: `/stores`,
  reports: `/reports`,
  invoicing: {
    invoicing: `/invoicing`,
    openInvoices: `/invoicing/open`,
    batchInvoices: (batchId = ':batchId') => `/invoicing/batch/${batchId}`,
    requestApproval: (batchId = ':batchId') => `/request-approval/${batchId}`,
    requestApprovalValidateAccess: (batchId = ':batchId') =>
      `/request-approval/${batchId}/validate-access`,
    requestApprovalReview: (batchId = ':batchId') =>
      `/request-approval/${batchId}/review`,
    requestApprovalSuccess: `/request-approval/success`,
    batchCompliance: (batchId = ':batchId') =>
      `/invoicing/batch-compliance/${batchId}`,
  },
  invoices: {
    invoices: `/invoices`,
  },
  settings: {
    dealerUsers: `/settings/users`,
    accountUsers: `/settings/users-account`,
    planProductsParts: `/settings/plan-products-parts`,
    contractTemplate: `/settings/contract-template`,
    dealer: `/settings/dealer`,
    store: `/settings/store`,
    products: `/settings/products`,
    models: `/settings/models`,
    materials: `/settings/materials`,
    plans: `/settings/plans`,
    globalConfig: `/settings/global-settings`,
    monetaryVariation: `/settings/monetary-settings`,
    chassis: `/settings/chassis`,
    settingsOptions: `/settings/`,
    priceTable: `/settings/price-table`,
    campaigns: `/settings/campaigns`,
    resendActivation: `/settings/resend-activation`,
    ipca: `/settings/ipca`,
    account: '/settings/account',
  },
};
